export enum Regions {
  BERayon1 = 'be-rayon1',
  BERayon2 = 'be-rayon2',
  BERayon3 = 'be-rayon3',
  BERayon4 = 'be-rayon4',
  BERayon5 = 'be-rayon5',
  BERayon6 = 'be-rayon6',

  Rayon1 = 'nl-rayon1',
  Rayon2 = 'nl-rayon2',
  Rayon3 = 'nl-rayon3',
  Rayon4 = 'nl-rayon4',
  Rayon5 = 'nl-rayon5'
}

export interface IContactPerson {
  emailAddress: string
  image: string
  name: string
  phoneNumber: string
  postalCodes: { fromPostalCode: number, toPostalCode: number }[] //not used for postalcode search
  regions: Regions[] // used for postalcode search
}

export interface IPostalCodeRange {
  from: number
  to: number
}
